export default __webpack_public_path__ + "src/assets/images/Book_Cover_Mockup-V2B.png";